export default function normalizeTransaction(transaction: any) {
  return {
    // accountingCode: transaction.accountingCode,
    id: transaction.id,
    branchId: transaction.BranchId,
    branch: transaction.Branch,
    projectId: transaction.ProjectId,
    project: transaction.Project,
    date: transaction.date,
    description: transaction.description,
    transactionId: transaction.id,
    transactionType: transaction.type,
    installmentItemId: transaction.InstallmentItemId,
    installmentId: transaction.installmentId,
    installMentItem: transaction.Installment_Item
  };
}
